import React from 'react'
import {animateScroll as scroll} from 'react-scroll';
import {FaFacebook,FaInstagram,FaTwitter,FaYoutube,FaGithub,FaLinkedin} from 'react-icons/fa'
import {FotterContainer, FotterWrap , FotterLinksContainer
    ,FotterLinkWrapper,FotterLinkItems, FotterLinkTitle,FotterLink
,SocialMedia,SocialMediaWrap,SocialLogo,WebsiteRights,
SocialIcons,SocialIconsLink} from "./FooterElements";


    const Fotter = () => {

        const toggleHome = () =>{
            scroll.scrollToTop();
        };

  return (
    <FotterContainer>
      <FotterWrap>
          {/* <FotterLinksContainer> */}
                {/* <FotterLinkWrapper> */}
                    {/* <FotterLinkItems>
                        <FotterLinkTitle>Footer Title</FotterLinkTitle>
                            <FotterLink to="/somthing">Somthing</FotterLink>
                            <FotterLink to="/somthing">Somthing else</FotterLink>  
                    </FotterLinkItems>
                    <FotterLinkItems>
                        <FotterLinkTitle>Footer Title</FotterLinkTitle>
                            <FotterLink to="/somthing">Somthing</FotterLink>
                            <FotterLink to="/somthing">Somthing else</FotterLink>
                    </FotterLinkItems>
                </FotterLinkWrapper>
                <FotterLinkWrapper>
                    <FotterLinkItems>
                        <FotterLinkTitle>Footer Title</FotterLinkTitle>
                            <FotterLink to="/somthing">Somthing</FotterLink>
                            <FotterLink to="/somthing">different</FotterLink>    
                    </FotterLinkItems>
                    <FotterLinkItems>
                        <FotterLinkTitle>Footer Title</FotterLinkTitle>
                            <FotterLink to="/somthing">Somthing</FotterLink>
                            <FotterLink to="/somthing">different</FotterLink>    
                    </FotterLinkItems> */}
                {/* </FotterLinkWrapper> */}
          {/* </FotterLinksContainer> */}

          <SocialMedia>
              <SocialMediaWrap>
                  <SocialLogo to="/" onClick={toggleHome}>Elad Barzilay</SocialLogo>
                  <WebsiteRights>Elad Barzilay © {new Date().getFullYear()} All rights reserved</WebsiteRights>
                    <SocialIcons>
                        <SocialIconsLink href="https://www.facebook.com/eladbar1/" target="_blank"  aria-label="Facebook">
                             <FaFacebook/>
                        </SocialIconsLink> 
                        {/* <SocialIconsLink href="/" target="_blank"  aria-label="Instagram">
                             <FaInstagram/>
                        </SocialIconsLink>    */}
                        <SocialIconsLink href="https://github.com/eladbarzilay" target="_blank"  aria-label="Github">
                             <FaGithub/>
                        </SocialIconsLink>
                        {/* <SocialIconsLink href="/" target="_blank"  aria-label="Twitter">
                             <FaTwitter/>
                        </SocialIconsLink> */}
                        <SocialIconsLink href="https://www.linkedin.com/in/elad-barzilay" target="_blank"  aria-label="Linkedin">
                             <FaLinkedin/>
                        </SocialIconsLink>
                    </SocialIcons>
              </SocialMediaWrap>
              </SocialMedia>

      </FotterWrap>
    </FotterContainer>
  )
}

export default Fotter
